import { render, staticRenderFns } from "./base.vue?vue&type=template&id=2481e590&scoped=true&"
import script from "./base.vue?vue&type=script&lang=js&"
export * from "./base.vue?vue&type=script&lang=js&"
import style0 from "./base.vue?vue&type=style&index=0&id=2481e590&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2481e590",
  null
  
)

export default component.exports